<template>
  <div class="features-highlight-b ">
    <div class="container pb-5">
      <div class="row">
        <div class="col-12">
          <h5 class="my-4">{{overrideTitle}}</h5>
          <a href="https://pytrace.com">
            <img class="img-fluid" src="../assets/pytrace-ui.png">
          </a>
          <div class="mb-2 mt-3"><span class="font-weight-bold">PyTrace</span> - Time Travel Debugger for Python:</div>
          <ul>
            <li>Record and replay code events and variable state.</li>
            <li>Call Graph shows exact sequence of events, that allows to quickly learn structure of unknown code with
              many dependencies.
            </li>
          </ul>
          <a href="https://pytrace.com" class="get-started__link ">
            <div class="get-started__button mb-4">
              Visit Website
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['override-title'],
    name: 'pc-pytrace-promo',
  }
</script>
<style scoped>

  .get-started__button {
    background: linear-gradient(123.71deg, #4E9B00 2.01%, #019C23 100%);
    box-shadow: -1px 1px 6px rgba(9, 157, 32, 0.22);
    /*box-shadow: -1px 1px px rgba(138, 150, 162, 0.8);*/
    border-radius: 4px;
    padding: .8em;
    width: 200px;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .get-started__button:hover {
    background: linear-gradient(123.71deg, #448700 2.01%, #019C23 100%);
    box-shadow: -1px 2px 10px rgba(9, 157, 32, 0.40);

  }

  .features-highlight-b {
    background-color: #343a40;
    color: #f8f9fa;
  }

  .get-started__link {
    text-decoration: none;
  }
</style>